import React, { useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form, Tab, TabPane } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { StyledTabWrapper } from '../../style'
import LanguageForm from './LanguageForm'
import i18n from '~/components/i18n'

interface SupportProps {
  languages: any[]
  countriesCodes: any[]
  tabIndex: number
}

const Support: React.FunctionComponent<SupportProps> = (props) => {
  const { t } = useTranslation()
  const { control, getValues, watch } = useFormContext()
  const [activeIndex, setActiveIndex] = useState<string | number>(0)
  const watchSupportStatus = watch('support.status')
  const watchSupportIcon = useWatch({ control, name: 'support.icon' })

  const supportIcons = [
    {
      label: i18n.t('headphones'),
      icon:'headphones'
    },
    {
      label: i18n.t('assistive listening systems'),
      icon:'assistive listening systems'
    },
    {
      label: i18n.t('phone volume'),
      icon:'phone volume'
    }
  ]

  useEffect(() => {
    if (props.tabIndex >= 0) {
      setActiveIndex(props.tabIndex)
    }
  }, [props.tabIndex])

  function renderForm() {
    return <>
      <Form.Group widths={5} style={{ alignItems: 'center' }}>
        <FormFields.Checkbox
          label={t('Show support information')}
          control={control}
          defaultValue={0}
          checkboxValue={1}
          name={'support.status'}
        />
        <FormFields.Select
          control={control}
          clearable
          placeholder={t('Select icon')}
          value={watchSupportIcon}
          rules={{
            required: watchSupportStatus
          }}
          withoutLabel
          options={supportIcons.map(supportIcon => (
            {
              value: supportIcon.icon,
              text: supportIcon.label,
              icon: supportIcon.icon
            }))}
          name={'support.icon'}
        />
      </Form.Group>
      <Tab
        menu={{ secondary: true, pointing: true }}
        activeIndex={activeIndex}
        renderActiveOnly={false}
        onTabChange={(_, data) => setActiveIndex(data.activeIndex)}
        panes={
          props.languages.map((lan, index) => {
            const languages = getValues('support.languages') || []
            const indexLanguage = languages.findIndex(language => language.id === lan.id)
            return {
              menuItem: lan.label,
              pane: <TabPane
              // eslint-disable-next-line
                children={<LanguageForm
                  index={indexLanguage}
                  key={lan.id}
                  watchSupportStatus={watchSupportStatus}
                  countriesCodes={props.countriesCodes}
                />}
                active={index === activeIndex}
                key={lan.id}
              />
            }
          })}
      >
      </Tab>
    </>
  }

  return <StyledTabWrapper>
    {renderForm()}
  </StyledTabWrapper>
}
export default Support
